/**
* Default javascript
*
* 
*
* @project Marlies Claasen 2019
* @version 1.0
* @author Wim Jurriaans
* @copyright 2019
* @license MIT
*
* @date 10-05-2019
* 
* 
*/

'use strict';

import blazy  from 'blazy';

let sitePath,
    menuTrigger,
    mainMenu,
    header,
    bLazy,
    currentAudioUrl = null,
    currentAudioTarget = null,
    audioPlayer; 


window.requestAnimFrame = (function() {
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();


const pageInit = e => {

  if(location.host == "localhost" || location.host == "localhost:3000" || location.host == "localhost:8888" || location.host == "192.168.0.85") {
    sitePath             = location.protocol + "//localhost/Marlies_2019/dist/";
  } else {
    sitePath             = location.protocol + "//" + location.host + "/";
  }
  
  bLazy             = new blazy({});
  header            = document.querySelector(".header-wrapper"); 
  menuTrigger       = document.querySelector('#menuTrigger');
  mainMenu          = document.querySelector('#menuMain');

  menuTrigger.addEventListener('click', handleMenu, false);

  let scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
  if(scrollPos > 10) {
    header.classList.add('header-wrapper--scrolled');
  } else {
    header.classList.remove('header-wrapper--scrolled');
  }

  document.querySelector("#submitBtn").addEventListener("click", handleForm, false);

  let scrollers = document.querySelectorAll('.scrollto');
  if(scrollers.length > 0) {
    addScrollerEvents(scrollers);
  }

  let audioPlayers = document.querySelectorAll(".js-audioplay");
  
  if(audioPlayers.length > 0) {
    audioPlayer = new Audio();
    addPlayerEvents(audioPlayers);
  }  
};

const handleMenu = evt => {
  evt.currentTarget.classList.toggle('menu__opener--open');
  mainMenu.classList.toggle('menu-main-wrapper--open');
};


const addPlayerEvents = players => {
  let nrOf = players.length;
  for(let i=0;i<nrOf;i++) {
    players[i].addEventListener('click', playAudio, false);
  }
}

const playAudio = evt => {
  let _target     = evt.target,
      _fileToPlay = _target.getAttribute('data-src');

  if(currentAudioTarget != null) currentAudioTarget.classList.remove('playing');
  
  if(currentAudioUrl == null || currentAudioUrl !== _fileToPlay) {
    currentAudioUrl = _fileToPlay;
    audioPlayer.src = _fileToPlay;
    audioPlayer.play();
    _target.classList.add('playing');
    currentAudioTarget = _target;
  } else if(currentAudioUrl == _fileToPlay && !audioPlayer.paused) {
      audioPlayer.pause();
      _target.classList.remove('playing');
  } else {
    audioPlayer.play();
    _target.classList.add('playing');
   }
      
}


const calculateMaxHeight = element => {
  let _width                = element.offsetWidth, 
      _height               = 0;

  element.style.position    = "absolute";
  element.style.left        = "-2000px";
  element.style.maxHeight   = "5000px";
  element.style.width       = _width + "px";
  _height                   = element.scrollHeight;
  element.style.position    = "";
  element.style.left        = "";
  element.style.width       = "";
  element.style.maxHeight   = "";
  return _height;
}


const addScrollerEvents = scrollers => {
  let nrOf = scrollers.length;
  for(let i=0;i<nrOf;i++) {
    scrollers[i].addEventListener('click', scrollToAnchor, false);
  }
}

const scrollToAnchor = e => {
  let element = String(e.currentTarget.getAttribute('data-anchor')),
          pos = 0;
  if(element != 'top')
    pos = document.getElementById(element).offsetTop - 200;
  
  scrollToY(pos, 1500, 'easeInOutQuint');
}

const scrollToY = (scrollTarget, scrollSpeed, scrollEasing) => {
    let scrollY = window.scrollY,
        scrollTargetY = scrollTarget || 0,
        speed = scrollSpeed || 2000,
        easing = scrollEasing || 'easeOutSine',
        currentTime = 0;

    let time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));

    let PI_D2 = Math.PI / 2,
        easingEquations = {
            easeOutSine: function (pos) {
                return Math.sin(pos * (Math.PI / 2));
            },
            easeInOutSine: function (pos) {
                return (-0.5 * (Math.cos(Math.PI * pos) - 1));
            },
            easeInOutQuint: function (pos) {
                if ((pos /= 0.5) < 1) {
                    return 0.5 * Math.pow(pos, 5);
                }
                return 0.5 * (Math.pow((pos - 2), 5) + 2);
            }
        };

    const tick = () => {
        currentTime += 1 / 60;
        var p = currentTime / time;
        var t = easingEquations[easing](p);
        if (p < 1) {
            requestAnimFrame(tick);
            window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        } else {
            window.scrollTo(0, scrollTargetY);
        }
    }

    tick();
}

/* ------------------------------------------------- FORM HANDELING */

const isFilled = val => {
  let regex     = /^\s*$/;
  let test      = !regex.test(val);
  return test;
};

const isEmail = val => {
  let regex     = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
  let test      = regex.test(val);
  return test;
};

const isPhone = val => {
  let regex     = /^(\+|00|0)(31\s?)?(6[\s-]?[1-9][0-9]{7}|[1-9][0-9][\s-]?[1-9][0-9]{6}|[1-9][0-9]{2}[\s-]?[1-9][0-9]{5})/;
  let test      = regex.test(val);
  return test;
};

const isZip = val => {
  let regex     = /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/;
  let test      = regex.test(val);
  return test;
};

const isNumber = val => {
  let regex     = /^[0-9]\d*$/;
  let test      = regex.test(val);
  return test;  
}

const notZero = val => {
  let regex     = /^[1-9]\d*$/;
  let test      = regex.test(val);
  return test;  
}

const forEachShow = (a, s) => {
  let l = a.length;
  for(let i=0;i<l;i++)
    a[i].style.display = s;
};

const showFormError = obj => {
  let err = document.createElement("div");
  let txt = document.createTextNode(obj.getAttribute('data-validation-message'));
  err.appendChild(txt);
  err.className  = "form-error";
  obj.parentNode.appendChild(err);
};

const hideFormError = obj => {
  let element = obj.parentNode.querySelector(".form-error");
  obj.parentNode.removeChild(element);
};

const handleForm = (evt) => {
  let formName         = evt.target.getAttribute('data-formid'),
      theForm          = document.getElementById(formName),
      formElements     = theForm.elements,
      nrOfFormElements = formElements.length,
      isValid          = true;

  for(let i=0;i<nrOfFormElements;i++) {
    let obj = formElements[i];
    if(obj.parentNode.getElementsByClassName("form-error").length > 0) {
      hideFormError(obj);
    }

    let validationType = obj.getAttribute('data-validation');
    if(obj.parentNode.getElementsByClassName("form-error").length > 0) {
      obj.parentNode.removeChild( obj.parentNode.getElementsByClassName("form-error")[0] );
      isValid = true;
    }
    
    if(validationType != null && (obj.parentNode.style.display !== 'none')) {
      let getRules = /validate\[(.*)\]/.exec(validationType);
      getRules.shift();
      
      switch(getRules[0]) {
        case "required":
        if(obj.type == "text" && !isFilled(obj.value)) {
          showFormError(obj);
          isValid = false;
        }
        if(obj.type == "textarea" && !isFilled(obj.value)) {
          showFormError(obj);
          isValid = false;
        }
        if(obj.type == "checkbox" && !obj.checked) {
          showFormError(obj);
          isValid = false;  
        }
        if(obj.tagName == "SELECT" && obj.value == "null") {
          showFormError(obj);
          isValid = false;  
        }
        break;
        case "integer":
          if (!isNumber(obj.value)) {
          showFormError(obj); 
          isValid = false;
        }
        break;
        case "notZero": 
          if (!notZero(obj.value)) {
            showFormError(obj); 
            isValid = false;
          }
        break;
        case "email":
          if (!isEmail(obj.value)) {
          showFormError(obj); 
          isValid = false;
        }
        break;
        case "phone":
          if (!isPhone(obj.value)) {
          showFormError(obj);
          isValid = false;  
        }
        break;
        case "zipcode":
        if (!isZip(obj.value)) {
          showFormError(obj);
          isValid = false;
        }
        break;
      }
    }
  }

  if(isValid) {
    sendAjaxForm();
  }

  for(let i=0;i<nrOfFormElements;i++) {
    formElements[i].addEventListener("focus", e => {
      let obj = e.target;
      if(obj.parentNode.getElementsByClassName("form-error").length > 0)
        hideFormError(e.target);
    }, false);
  };
};

const sendAjaxForm = () => {
  let data = {
            clt_name    : document.getElementById("clt_name").value,
            clt_mail    : document.getElementById("clt_mail").value,
            clt_comment : document.getElementById("clt_question").value
        };

  postAjax(sitePath + "includes/ajaxmail.php", data, function(data) {
    document.getElementById("contactInPage").style.display = 'none';
    document.getElementById("theThanks").innerHTML         = data;
    document.getElementById("theThanks").style.display     = 'block';
  }, function() {
    document.getElementById("contactInPage").style.display = 'none';
    document.getElementById("theThanks").innerHTML         = data;
    document.getElementById("theThanks").style.display     = 'block';
  }); 
};


const postAjax = (url, data, success, error) => {
    let params = typeof data == 'string' ? data : Object.keys(data).map(
            (k) =>  encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) 
        ).join('&');

    let xhr = XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open('POST', url);
    xhr.onreadystatechange = function() {
        if (xhr.readyState>3 && xhr.status==200) { 
          success(xhr.responseText); 
        } else {
          error();
        }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(params);
    return xhr;
}

//BINDING EVENTS
if (document.addEventListener) document.addEventListener("DOMContentLoaded", pageInit, false);

window.addEventListener('resize', () => {
  bLazy.revalidate();
}, false);

window.addEventListener('scroll', () => {
  let scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
  if(scrollPos > 10) {
    header.classList.add('header-wrapper--scrolled');
  } else {
    header.classList.remove('header-wrapper--scrolled');
  }
}, false);



// WEBPACK FOOTER //
// ./src/js/src/default.js